import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import type { IAuthState } from "./types";
import { endpoints as originAuthEndpoints } from "../../../services/origin/authApi/authApi";
import { endpoints as adminAuthEndpoints } from "../../../services/admin-service/authApi/authApi";
import type { IUser } from "../../../services/origin/authApi/types";

export const authInitialState: IAuthState = {};

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    setAccessToken: (state, { payload }: PayloadAction<string>) => {
      state.accessToken = payload;
    },
    setUser: (state, { payload }: PayloadAction<IUser>) => {
      state.user = payload;
    },
    clearAuthData: (state) => {
      state.accessToken = undefined;
      state.user = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      adminAuthEndpoints.loginRequest.matchFulfilled,
      (state, { payload }) => {
        state.accessToken = payload.accessToken;
        state.user = payload.user;
      }
    );
    builder.addMatcher(
      adminAuthEndpoints.magicLinkLoginSubmit.matchFulfilled,
      (state, { payload }) => {
        state.accessToken = payload.accessToken;
        state.user = payload.user;
      }
    );
    builder.addMatcher(
      adminAuthEndpoints.getUserRequest.matchFulfilled,
      (state, { payload }) => {
        state.user = payload;
      }
    );
    builder.addMatcher(
      originAuthEndpoints.getUserStatsRequest.matchFulfilled,
      (state, { payload }) => {
        state.userInfo = payload;
      }
    );
  },
});

export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectCurrentUserOutstandingBalance = (state: RootState) =>
  state.auth.userInfo?.billing.amountOutstanding;


export const { setAccessToken, setUser, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
